{
    "common": {
        "mon": "Pzt",
        "tue": "Sal",
        "wed": "Çar",
        "thu": "Per",
        "fri": "Cum",
        "sat": "Cmt",
        "sun": "Paz",
        "jan": "Oca",
        "feb": "Şub",
        "mar": "Mar",
        "apr": "Nis",
        "jun": "Haz",
        "jul": "Tem",
        "aug": "Ağu",
        "sep": "Eyl",
        "oct": "Eki",
        "nov": "Kas",
        "dec": "Ara",
        "january": "Ocak",
        "february": "Şubat",
        "march": "Mart",
        "april": "Nisan",
        "may": "Mayıs",
        "june": "Haziran",
        "july": "Temmuz",
        "august": "Ağustos",
        "september": "Eylül",
        "october": "Ekim",
        "november": "Kasım",
        "december": "Aralık",
        "checkin": "Giriş",
        "checkout": "Çıkış",
        "room": "Oda",
        "rooms": "Odalar",
        "adult": "Yetişkin",
        "adults": "Yetişkinler",
        "edit": "Düzenle",
        "editCap": "DÜZENLE",
        "delete": "Sil",
        "deleteCap": "SİL",
        "localTime": "Yerel Saat",
        "back": "GERİ",
        "home": "ANA SAYFA",
        "yes": "EVET",
        "no": "HAYIR",
        "left": "Kalan",
        "hour": "Saat",
        "hours": "Saat",
        "night": "gece",
        "nights": "gece",
        "for": "için",
        "why": "Neden",
        "get": "Al",
        "more": "Daha Fazla",
        "agree": "KABUL ET",
        "disagree": "REDDET",
        "basedOn": "dayalı",
        "error": "Bir hata oluştu, lütfen daha sonra tekrar deneyin",
        "error2": "Başarısız, tekrar deneyin!",
        "error3": "Bir Hata Oluştu!!",
        "error4": "Bir hata oluştu!! Lütfen tekrar deneyin",
        "error5": "Üzgünüz!! Bir hata oluştu. Lütfen bir süre sonra tekrar deneyin.",
        "hi": "Merhaba",
        "to": "e",
        "free": "Ücretsiz",
        "per": "Başına",
        "at": "de",
        "day": "Gün",
        "days": "Gün",
        "time": "Zaman",
        "of": "in",
        "photo": "Fotoğraf",
        "photos": "Fotoğraflar",
        "done": "Tamam",
        "fullStay": "Tam Konaklama",
        "date": "Tarih",
        "and": "ve",
        "bookingDetail": "Rezervasyon Detayı",
        "Back": "Geri",
        "Home": "Ana Sayfa"
    },
    "userPopup": {
        "myAccount": "Hesabım",
        "welcome": "Hoş Geldiniz",
        "user": "Kullanıcı",
        "findMyBookings": "REZERVASYONLARIMI BUL",
        "viewProfile": "PROFİLİ GÖRÜNTÜLE",
        "makeAReservarion": "REZERVASYON YAP",
        "logout": "ÇIKIŞ YAP",
        "loginCap": "GİRİŞ YAP",
        "login": "Giriş Yap",
        "invalidCredentials": "Geçersiz kimlik bilgileri",
        "invalidEmail": "Geçersiz E-posta",
        "passwordIsRequired": "Şifre gerekli",
        "minChar8": "minimum 8 karakter",
        "tooShort": "Çok Kısa!",
        "tooLong": "Çok Uzun!",
        "required": "Gerekli",
        "emailInvalid": "Geçerli bir e-posta girin",
        "passwordInvalid": "Geçerli bir şifre girin",
        "phNumInvalid": "Telefon numarası geçerli değil",
        "signupCap": "KAYIT OL",
        "signup": "Kayıt Ol",
        "verifyText": "Sizin olduğunuzu doğrulayın",
        "verifyText2": "E-posta adresinize bir doğrulama kodu gönderdik",
        "verificationCode": "Doğrulama Kodu",
        "didNotReceiveEmail": "E-posta almadınız",
        "clickToResend": "Yeniden göndermek için tıklayın",
        "verifyAndSignIn": "Doğrula ve Giriş Yap",
        "otpSentSuccessfully": "OTP başarıyla gönderildi",
        "somethingWentWrong": "Bir şeyler yanlış gitti, lütfen tekrar deneyin",
        "otpError": "Lütfen geçerli bir numara girin",
        "otpError2": "Lütfen sadece sayı girin",
        "otpError3": "Yanlış OTP, lütfen tekrar deneyin",
        "otpError4": "OTP Süresi Doldu, tekrar denemek için Yeniden Gönder'e tıklayın",
        "otpError5": "Lütfen tekrar deneyin",
        "forgetPassword": "Şifremi Unuttum",
        "submitError": "Kullanıcı mevcut değil!",
        "userExistError": "Kullanıcı Zaten Mevcut",
        "checkYourEmail": "E-postanızı kontrol edin",
        "passwordResetLinkSent": "Şifre sıfırlama bağlantısını gönderdik",
        "noWorriesResetInstructions": "Endişelenmeyin, size sıfırlama talimatları göndereceğiz.",
        "enterYourEmail": "E-posta adresinizi girin",
        "resetMyPassword": "ŞİFREMİ SIFIRLA",
        "setANewPassword": "Yeni bir şifre belirle",
        "newPassword": "Yeni Şifre",
        "confirmPassword": "Şifreyi Onayla",
        "confirmPasswordError": "Şifreler eşleşmelidir",
        "backToLogin": "Giriş'e Geri Dön",
        "dontHaveAccount": "Hesabınız yok mu?",
        "alreadyHaveAccount": "Zaten hesabınız var mı?",
        "memberDiscount1": "Alacaksınız",
        "memberDiscount2": "üye indirimi sonsuza kadar.",
        "discount1": "Tüm rezervasyonlarınızı tek yerden yönetin.",
        "discount2": "Kişiselleştirilmiş öneriler ve özel deneyimler için kayıt olun!!",
        "discount3": "Mutlu misafirler topluluğumuza katılın ve konaklamanızı planlamaya başlayın.",
        "leftGridText1": "Tüm rezervasyonlarınızı tek yerden yönetin",
        "leftGridText2": "Kişiselleştirilmiş öneriler ve özel deneyimler için kayıt olun!!",
        "leftGridText3": "Mutlu misafirler topluluğumuza katılın ve konaklamanızı planlamaya başlayın",
        "gridDiscountText1": "üye indirimi",
        "gridDiscountText2": "seçili mülklerde sonsuza kadar",
        "gridDiscountText3": "Özel deneyim için sonsuza kadar giriş yapın",
        "gridDiscountText4": "Özel Üye Avantajları Alın",
        "findBookingError": "E-posta ve rezervasyon kimliğiniz eşleşmiyor",
        "verifyAndConfirmBooking": "Rezervasyonu doğrula ve onayla",
        "confirmEmailText": "E-posta adresinize bir doğrulama kodu gönderdik",
        "enterCodeText": "Size gönderilen doğrulama kodunu girin",
        "didNotRecieveEmail": "E-posta almadınız mı?",
        "changeEmailText": "E-posta adresini değiştirmek için buraya tıklayın",
        "verifyAndConfirm": "Doğrula ve Onayla",
        "verified": "DOĞRULANDI",
        "bookingExpired": "Rezervasyon Süresi Doldu",
        "bookingExpiredText": "Üzgünüz, kullandığınız rezervasyon kimliği süresi doldu",
        "backToFindingBooking": "Rezervasyon Bulmaya Geri Dön",
        "findMyBooking": "Rezervasyonlarımı Bul",
        "bookingEmail": "Rezervasyon E-postası",
        "reservationId": "Rezervasyon Kimliği",
        "findBooking": "REZERVASYON BUL",
        "abandonmentCartDoneText1": "Teşekkürler!",
        "abandonmentCartDoneText2": "Sepet detaylarınız e-postaya gönderildi. Rezervasyonunuza istediğiniz zaman devam edin.",
        "Recommended Currencies": "Önerilen Para Birimleri",
        "All currencies": "Tüm para birimleri",
        "thisIsRequiredField": "Bu gerekli bir alandır"
    },
    "widget": {
        "destination": "Destinasyon",
        "enterDestination": "Destinasyon Girin",
        "guests": "Misafirler",
        "nationality": "Uyruk",
        "selectNationality": "Uyruk seçin",
        "nationalityIsRequired": "Uyruk gereklidir",
        "selectedRate": "Özel fiyat",
        "search": "Ara",
        "ages": "Yaşlar",
        "orAbove": "Veya Üzeri",
        "child": "Çocuk",
        "children": "Çocuklar",
        "addAnotherRoom": "Başka Oda Ekle",
        "removeRoom": "Odayı Kaldır",
        "property": "Mülk",
        "city": "Şehir",
        "country": "Ülke",
        "bookNow": "Şimdi Rezervasyon Yap",
        "overnightStay": "Gecelik Konaklama",
        "dayUse": "Gündüz Kullanımı",
        "destinationIsRequired": "Destinasyon gerekli",
        "checkInIsRequired": "Giriş tarihi gerekli",
        "checkOutIsRequired": "Çıkış tarihi gerekli",
        "noLocationFound": "Konum Bulunamadı",
        "soldOut": "Tükendi",
        "highDemand": "Yüksek Talep",
        "dates": "Tarihler",
        "allRates": "Tüm oranlar",
        "K": "K",
        "M": "M",
        "sameDayCheckout": "Aynı gün çıkış"
    },
    "promotion": {
        "headingText": "Önemli Bilgiler",
        "regularRate": "Yok",
        "seniorCitizen": "Yaşlı Vatandaş Oranı",
        "agencyRate": "Acenta Oranı",
        "caaRate": "CAA/AAA Oranı",
        "corporateRate": "Kurumsal Oran",
        "governmentRate": "Hükümet/Askeri Oran",
        "promotionalSpecialRate": "Promosyon/Özel Oran",
        "regularRateDescription": "Herhangi bir promosyon uygulanmadı.",
        "seniorCitizenRateDescription": "Bu, genellikle 60 yaş ve üzeri yetişkinler için kapsamlı olarak mevcut olan indirimli otel oranıdır.",
        "agencyRateDescription": "Bu, yalnızca belirli seyahat acenteleri aracılığıyla erişilebilen, ortaklık ve işbirliğini teşvik eden indirimli otel oranıdır.",
        "caaRateDescription": "Bu, AAA veya CAA üyelerine özel tasarruflar için sunulan özel otel oranıdır.",
        "corporateRateDescription": "Bu, genellikle otel ile kurumsal varlık arasında müzakere edilen iş seyahatçileri için uzatılan indirimli otel oranıdır.",
        "governmentRateDescription": "Bu oran planı, otel odası rezervasyonu için Hükümet/Askeri personel için özel indirimler sunar.",
        "contentSeniorCitizen": "Giriş sırasında doğum tarihi kanıtı zorunludur. İlgili kimlik sunulamaması durumunda geçerli tarifeler uygulanacaktır.",
        "contentAgencyRate": "Varışınızda rezervasyon onayınızı ve kimlik kanıtınızı bulundurduğunuzdan emin olun. Bunların sunulamaması durumunda standart oranlar uygulanacaktır.",
        "contentPromotionalSpecialRate": "Bu, genellikle belirli etkinlikler, sezonlar veya pazarlama kampanyalarıyla bağlantılı olan sınırlı süre için sunulan indirimli otel oranıdır.",
        "contentCaaRate": "Lütfen giriş sırasında CAA üyelik kartınızı veya ilgili kimliğinizi bulundurduğunuzdan emin olun. İlgili kimlik sunulamaması durumunda geçerli tarifeler uygulanacaktır.",
        "contentCorporateRate": "Giriş sırasında şirket kimliği kanıtı veya diğer resmi belgeler gereklidir. İlgili kanıt sunulamaması durumunda geçerli tarifeler uygulanacaktır.",
        "contentGovernmentRate": "Giriş sırasında geçerli hükümet veya askeri kimlik sağlanmalıdır. Gerekli kimliğin sağlanamaması durumunda standart oranda ücretlendirme yapılacaktır.",
        "CORP": "CORP",
        "AGEN": "AGEN",
        "PROM": "PROM",
        "apply": "UYGULA",
        "Offer Code": "Teklif Kodu",
        "Agency Code": "Acenta Kodu",
        "Corporate Code": "Kurumsal Kod",
        "All-Access Rate": "Tüm Erişim Oranı",
        "errorCode": "Bu kod geçerli değil"
    }
} 